

















































































































































import SeletorDeCfop from '@/components/fiscal/SeletorDeCfop.vue'
import SeletorDeCst from '@/components/fiscal/SeletorDeCst.vue'
import CampoDecimal from '@/components/ui/CampoDecimal.vue'
import DatePicker from '@/components/ui/DatePicker.vue'
import { InfoNotaComplementar } from '@/models'
import { ProdutoService } from '@/services'
import { maiorOuIgualAZero, maiorQueZero, obrigatorio, validarCampoObrigatorio } from '@/shareds/regras-de-form'
import { criarItemDaVenda } from '@/shareds/venda-shareds'
import { VendaModule } from '@/store/vuex/venda/VendaStore'
import type { NotaFiscalServiceAdapter } from '@/usecases'
import { Vue, Component, PropSync, Watch, Ref, Prop } from 'vue-property-decorator'
import { Inject } from 'inversify-props'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'

@Component({
	components: {
		SeletorDeCfop,
		SeletorDeCst,
		CampoDecimal,
		DatePicker,
	},
})
export default class NotaComplementarView extends Vue {
	@PropSync('mostra', { type: Boolean, default: true }) syncMostra!: boolean
	@Prop() vendaId!: string
	@Ref() form!: HTMLFormElement
	@Ref() menuHora!: { save: (value: any) => void }

	obrigatorio = obrigatorio
	maiorQueZero = maiorQueZero
	maiorOuIgualAZero = maiorOuIgualAZero
	validarCampoObrigatorio = validarCampoObrigatorio

	@Inject('NotaFiscalServiceAdapter')
	private notaFiscalService!: NotaFiscalServiceAdapter

	findProduto = new ProdutoService()

	infoNotaComplementar: InfoNotaComplementar = criarInfoNotaComplementar()
	infoAdicionais = ''
	loading = false
	carregando = false
	dataEmissao: string | null = null
	horaEmissao: string | null = null
	mostraMenuHora = false

	@Watch('syncMostra')
	async onMostraChange() {
		try{
			this.loading = true
			if (this.syncMostra && this.vendaId) {
				const infoNotaComplementarNota = await this.notaFiscalService.findInfoNotaComplementarByVendaId(this.vendaId)
				
				this.infoNotaComplementar = {
					...infoNotaComplementarNota,
				}
				this.inicializarDataHora()
			}
			this.loading = false
		} catch (error) {
			AlertModule.setError(error)
			this.loading = false
		}
		
	}

	atualizandoDhEmissao = false

	@Watch('infoNotaComplementar.dhEmissao', { immediate: true })
	inicializarDataHora() {
		if (this.atualizandoDhEmissao) return
		
		if (this.infoNotaComplementar.dhEmissao) {
			const data = new Date(this.infoNotaComplementar.dhEmissao)
			const novaData = data.toISOString().substr(0, 10)
			const horas = String(data.getHours()).padStart(2, '0')
			const minutos = String(data.getMinutes()).padStart(2, '0')
			const novaHora = `${horas}:${minutos}`
			
			if (this.dataEmissao !== novaData) {
				this.dataEmissao = novaData
			}
			if (this.horaEmissao !== novaHora) {
				this.horaEmissao = novaHora
			}
		} else {
			this.dataEmissao = null
			this.horaEmissao = null
		}
	}

	@Watch('dataEmissao')
	onDataEmissaoChange() {
		this.atualizarDhEmissao()
	}

	@Watch('horaEmissao')
	onHoraEmissaoChange() {
		this.atualizarDhEmissao()
	}

	salvarHora() {
		if (this.menuHora && this.horaEmissao) {
			this.menuHora.save(this.horaEmissao)
		}
		this.atualizarDhEmissao()
	}

	atualizarDhEmissao() {
		this.atualizandoDhEmissao = true
		
		if (this.dataEmissao && this.horaEmissao) {
			const [horas, minutos] = this.horaEmissao.split(':')
			const dataHora = new Date(this.dataEmissao)
			dataHora.setHours(parseInt(horas) || 0)
			dataHora.setMinutes(parseInt(minutos) || 0)
			dataHora.setSeconds(0)
			dataHora.setMilliseconds(0)
			this.infoNotaComplementar.dhEmissao = dataHora
		} else if (this.dataEmissao) {
			const dataHora = new Date(this.dataEmissao)
			dataHora.setHours(0)
			dataHora.setMinutes(0)
			dataHora.setSeconds(0)
			dataHora.setMilliseconds(0)
			this.infoNotaComplementar.dhEmissao = dataHora
		} else {
			this.infoNotaComplementar.dhEmissao = null
		}
		
		this.$nextTick(() => {
			this.atualizandoDhEmissao = false
		})
	}

	@Watch('infoNotaComplementar', { deep: true })
	calcularImpostoVIcms() {
		if(this.infoNotaComplementar.valorBcICMS === null || this.infoNotaComplementar.percentualICMS === null) return

		this.infoNotaComplementar.valorICMS = this.infoNotaComplementar.valorBcICMS * this.infoNotaComplementar.percentualICMS / 100
	}

	onlyNumbers(event) {
		if (!/^\d$/.test(event.key)) {
			event.preventDefault();
		}
	}

	async concluir() {
		if (!this.form.validate()) return

		try {
			this.carregando = true

			if(VendaModule.emissaoEntradaAtual) {
				const filtros = 'NFS.50.131223.2782050.1'
				const produtoNotaComplementar = await this.findProduto.encontrarProdutoPorIdentificador(filtros)
				VendaModule.emissaoEntradaAtual.itens.push(criarItemDaVenda(produtoNotaComplementar, 1))
				VendaModule.emissaoEntradaAtual.infoAdicionais = this.infoAdicionais
				VendaModule.emissaoEntradaAtual.tipoDeTransacao = 'Complementar'
			}

			this.$emit('concluir', this.infoNotaComplementar)
			this.form.resetValidation()
			this.infoNotaComplementar = criarInfoNotaComplementar()
			this.dataEmissao = null
			this.horaEmissao = null
			this.syncMostra = false
			this.carregando = false
		} catch (error) {
			this.carregando = false
			AlertModule.setError(error)
		}

	}

	cancelar() {
		this.form.resetValidation()
		this.infoNotaComplementar = criarInfoNotaComplementar()
		this.dataEmissao = null
		this.horaEmissao = null
		this.$emit('update:mostra', false)
	}
}

function criarInfoNotaComplementar(): InfoNotaComplementar {
	return {
		cstICMS: null,
		cfop:  null,
		origemICMS: 0,
		modBcICMS: 0,
		valorBcICMS: 0,
		percentualICMS: 0,
		valorICMS: 0,
		chnfeReferencia: '',
		infoAdicionais: '',
		dhEmissao: null,
	}
}
